import { QuickAddComponent } from './../../../../components/quick-add/quick-add.component';
import { Component, Input, OnInit, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { TabsComponent } from 'root/components';
import { FrontendContextService } from 'root/services';
import { Subscription } from 'rxjs';
import { ProductCodeandQuantityDto, SessionDeliverySequenceViewModel } from 'root/mibp-openapi-gen/models';
import { MibpSessionService } from 'root/services/mibp-session/mibp-session.service';
import { MySandvikFeatures } from 'root/services/permission';

import { ResourceStringComponent } from 'root/shared/components/localization/resource-string/resource-string.component';
import { SystemMessageComponent } from 'root/components/system-message/system-message.component';
import { TabComponent } from 'root/components/tabs/tab.component';
import { QuickAddTemplateComponent } from 'root/components/quick-add-template/quick-add-template.component';
import { QuickAddImportComponent } from 'root/components/quick-add-import/quick-add-import.component';
import { permissionPolicyKey } from 'root/services/permission';
import { TestIdDirective } from 'root/directives/testid/testid.directive';


@Component({
  selector: 'mibp-dashboard-quickadd',
  templateUrl: './dashboard-tile-quickadd.component.html',
  styleUrls: ['./dashboard-tile-quickadd.component.scss', '../../modules/dashboard/pages/temporary-tiles.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ResourceStringComponent, SystemMessageComponent, TabsComponent, TabComponent, QuickAddComponent, QuickAddTemplateComponent, QuickAddImportComponent, TestIdDirective]
})

export class DashboardTileQuickaddComponent implements OnInit {
  private frontendContext = inject(FrontendContextService);
  private sessionService = inject(MibpSessionService);


  deliverySequence: SessionDeliverySequenceViewModel;
  isDeliverySequenceRequired = false;
  hasCreateCartPermission: boolean;
  deliverySequenceSubscription: Subscription;
  hasTemplatePermission: boolean;

  @Input() hideTitle = false;
  @Input() compactLayout = false;
  @Input() skipFocus = true;
  @Input() isOnTile = false;

  @ViewChild(TabsComponent) tabs: TabsComponent;
  @ViewChild(QuickAddComponent) quickAdd: QuickAddComponent;

  ngOnInit(): void {
    this.hasCreateCartPermission = this.frontendContext.testPermission(permissionPolicyKey('canAddToCart'));
    this.hasTemplatePermission = this.frontendContext.testPermission(permissionPolicyKey('canUseTemplates'));
    this.isDeliverySequenceRequired = !this.sessionService.hasFeature(MySandvikFeatures.ShopPersistentCart);

    this.deliverySequenceSubscription = this.sessionService.activeDeliverySequence$.subscribe(deliverySequence => {
      this.deliverySequence = deliverySequence;
    });
  }

  filesImported(files: ProductCodeandQuantityDto[]): void {
    this.tabs.setActiveTab(0);
    this.quickAdd.addFromImport(files);
  }
}
